import { render, staticRenderFns } from "./PosicionesCardsComponent.vue?vue&type=template&id=5f43db90&"
import script from "./PosicionesCardsComponent.vue?vue&type=script&lang=js&"
export * from "./PosicionesCardsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports